import React, {useState, useRef} from 'react';
import {DayPicker} from 'react-day-picker';
//import 'react-day-picker/lib/style.css';
import {format, isBefore, isFuture, parse, parseISO, endOfToday} from 'date-fns';
import * as S from './DatePicker.styles';

//import './DatePicker.css';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const DatePicker = ({
  width,
  breakpoint,
  handleSearchStep,
  selectTab,
  handleSelectTab,
  startDateLabel,
  endDateLabel,
  singleDate = true,
  from,
  to,
  setFrom,
  setTo,
  changeHandler,
  name,
  mode,
  hidePreviousDate,
  endDate,
}) => {
  const [enteredTo, setEnteredTo] = useState(null);
  const today = new Date();
  const [selectedSingleDay, setSelectedSingleDay] = useState<Date | undefined>(today);

  const formattedDate: Date = new Date(parseISO(endDate, 'yyyy-mm-dd'));

  const handleDateTab = index => {
    handleSelectTab(index);
  };

  const isSelectingFirstDay = (from, to, day) => {
    const isBeforeFirstDay = from && isBefore(day, from);
    const isRangeSelected = from && to;
    return !from || isBeforeFirstDay || isRangeSelected;
  };

  const handleDayClick = day => {
    if (from && to && day >= from && day <= to) {
      handleResetClick();
      return;
    }
    if (isSelectingFirstDay(from, to, day)) {
      setFrom(day);
      setTo(null);
      setEnteredTo(null);
      handleDateTab(1);
    } else {
      setTo(day);
      setEnteredTo(day);
      handleDateTab(0);
    }
  };

  const handleDayMouseEnter = day => {
    if (!isSelectingFirstDay(from, to, day)) {
      setEnteredTo(day);
    }
  };

  const handleResetClick = () => {
    setFrom(from);
    setTo(to);
    setEnteredTo(enteredTo);
  };

  const handleSelectedSingleDay = (day, {selected}) => {
    changeHandler && changeHandler(format(new Date(day), 'yyyy-MM-dd'), name);
    setSelectedSingleDay(selected ? new Date(day) : day);
    handleSearchStep('');
  };

  const modifiers = {start: from, end: to};
  const disabledDays = {before: from};
  const selectedDays = [from, {from, to}];

  const getFromDate = () => {
    if (from) {
      return `${from.getDate()} ${months[from.getMonth()]} 20${from.getFullYear() % 2000}`;
    }

    return startDateLabel;
  };
  const getToDate = () => {
    if (to) {
      return `${to.getDate()} ${months[to.getMonth()]} 20${to.getFullYear() % 2000}`;
    }

    return endDateLabel;
  };

  const isInvalidDate = (day: Date): boolean => {
    if (day < new Date(formattedDate) || day > endOfToday()) {
      return true;
    } else return false;
  };

  return (
    <S.Conitaner className="datePickerConatiner">
      <div className="datePickerWrap">
        {width > breakpoint ? (
          <ul className="dateTab">
            {singleDate ? (
              <>
                <li className={` ${from == null ? 'active' : ''}`} onClick={() => handleDateTab(0)}>
                  <p className="dateType">{startDateLabel}</p>
                  <p className="dateFormat">
                    <span className="dateMonthText">{getFromDate()}</span>
                  </p>
                </li>
              </>
            ) : (
              <>
                <li className={` ${!selectTab ? 'active' : ''}`} onClick={() => handleDateTab(0)}>
                  <p className="dateType">{startDateLabel}</p>
                  <p className="dateFormat">
                    <span className="dateMonthText">{getFromDate()}</span>
                  </p>
                </li>
                <li className={`${selectTab ? 'active' : ''}`} onClick={() => handleDateTab(1)}>
                  <p className="dateType">{endDateLabel}</p>
                  <p className="dateFormat">
                    <span className="dateMonthText">
                      <span className="dateMonthText">{getToDate()}</span>
                    </span>
                  </p>
                </li>
              </>
            )}
          </ul>
        ) : (
          <div className="dateSelectHeader">
            <span className="sprite arrowBackIcon"></span> Select Travel date
          </div>
        )}

        {singleDate ? (
          <S.Conitaner>
            <DayPicker
              selectedDays={selectedSingleDay}
              required
              selected={selectedSingleDay}
              onSelect={handleSelectedSingleDay}
              mode={mode || 'single'}
              className="Range"
              singlMode={singleDate}
              disabled={day => isInvalidDate(day)}
            />
          </S.Conitaner>
        ) : (
          <>
            <DayPicker
              className="Range"
              numberOfMonths={width > breakpoint ? 2 : 12}
              selected={selectedDays}
              modifiers={modifiers}
              onDayClick={handleDayClick}
              onDayMouseEnter={handleDayMouseEnter}
              mode={mode}
              pagedNavigation
            />
          </>
        )}

        <div className="dateBtnWrap">
          {width > breakpoint && (
            <span className="cancelDate" onClick={handleSearchStep}>
              {' '}
              Cancel
            </span>
          )}
          <button onClick={handleSearchStep} className="dateDoneBtn">
            Done
          </button>
        </div>
      </div>
    </S.Conitaner>
  );
};

export default DatePicker;
